module.exports = __webpack_public_path__ + "img/banner09_01-03.c326931c.png";